module.exports = __webpack_public_path__ + "img/teasers_1.b951d2a0.jpg";